/**
 * Content-Design-authored copy for `m1-portal-capability-boundary` TG-4's
 * two wrapper components. No lorem, no placeholder, no developer-drafted
 * wording left unreviewed.
 *
 * `sectionConfirmControlLabel` matches `features/renewal-capture/content.ts`'s
 * own `confirmSectionLabel` ("Confirm this section") verbatim -- one voice
 * for the one per-section confirmation control (`docs/UBIQUITOUS_LANGUAGE.md`,
 * ADR-20260821-5wwj) the whole portal shares, not a second invention of the
 * same control's text. `SectionConfirmControl` owns this string so a future
 * caller never re-authors it locally.
 *
 * `accessNotConfirmed` is new copy, reviewed against ADR-20260826-82qe's
 * requirement: tell the customer plainly that their access could not be
 * confirmed, and how to get help -- never a blank screen indistinguishable
 * from a broken page, and never an internal identifier, stack frame or
 * claim field (`heading`/`message` below name none). Plain, active voice
 * ("we"), matching this feature's other authored copy
 * (`routing/reload-failure-copy.ts`, `features/declaration/content.ts`).
 * "Foundation Risk Partners" is the full business name this portal's other
 * customer-facing copy already uses (`features/declaration/content.ts`'s
 * own declaration `statement`) -- "account manager" is the help contact
 * this portal names elsewhere for a customer who needs a human
 * (`docs/UBIQUITOUS_LANGUAGE.md`'s owner-user identity entry). No phone
 * number or email address is invented here: none is recorded anywhere in
 * this repository to copy from.
 */
export const sectionConfirmControlContent = {
  label: "Confirm this section",
} as const;

export const accessNotConfirmedContent = {
  heading: "We could not confirm your access",
  message:
    "We could not confirm that you have access to this renewal. If you think this is wrong, contact your Foundation Risk Partners account manager for help.",
} as const;
